import { render, staticRenderFns } from "./CartAbandonment.vue?vue&type=template&id=fe5e54d4"
import script from "./CartAbandonment.vue?vue&type=script&lang=js"
export * from "./CartAbandonment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports